<template>
  <div>
    <vessel-machine-test-table :id="id"></vessel-machine-test-table>
  </div>
</template>

<script>
import VesselMachineTestTable from '@/components/tables/VesselMachineTestTable.vue'

export default {
  name: 'VesselMachine',
  components: {
    VesselMachineTestTable
  },
  props: {
    id: String
  }
}
</script>

<style scoped></style>
